const visibility = state => state.visibility

export const coverShareButtonsInView = state => !visibility(state).coverShareButtonsInView

export const shouldShowNavigationInMobile = state =>
  (visibility(state).isScrollUp && window.NM.i18n.locale !== 'de') ||
  !visibility(state).titleIsAboveViewport



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/visibility/visibility.selectors.js